module.exports = __webpack_public_path__ + "img/sq-6.405efd2e.jpg";